import type { Reducer } from 'redux';

import type { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import type { MsGraphConfig } from './types';

export type SessionAction = SessionConfigureAction;

const initialState: MsGraphConfig = { recentFilesPath: '' };

const reducer: Reducer<MsGraphConfig, SessionAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.msGraph;
    default:
      return state;
  }
};

export default reducer;
